{
  "(optional)": "（オプション）",
  "(required)": "（必須）"
}
